import { Base } from '@app/shared/model';

export class Department extends Base {
    name: string;

    constructor(contentResponse: any) {
        super(contentResponse);
        this.name = contentResponse.name;
    }
}
